import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../context/axios";

const AgencyRequests = () => {
  const [agencies, setAgencies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [agenciesPerPage] = useState(10);

  useEffect(() => {
    const fetchAgencies = async () => {
      try {
        const response = await axios.get("/agency-requests");
        setAgencies(response.data.data);
      } catch (error) {
        console.error("Error fetching agency requests:", error);
      }
    };

    fetchAgencies();
  }, []);

  const handleStatusChange = async (agencyId, newStatus) => {
    try {
      await axios.patch(`/agency-requests/${agencyId}`, {
        status: newStatus === "active",
      });

      // Update local state immediately for better UX
      setAgencies((prev) =>
        prev.map((agency) =>
          agency._id === agencyId ? { ...agency, status: newStatus === "active" } : agency
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const indexOfLastAgency = currentPage * agenciesPerPage;
  const indexOfFirstAgency = indexOfLastAgency - agenciesPerPage;
  const currentAgencies = agencies.slice(indexOfFirstAgency, indexOfLastAgency);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="min-h-screen py-12 px-6">
      <div className="max-w-7xl mx-auto p-6 rounded-lg">
        <h2 className="text-4xl font-extrabold text-indigo-600 mb-8">
          Agency Requests
        </h2>

        <div className="overflow-x-auto rounded-md border border-gray-200 shadow-sm">
        <table className="min-w-full text-sm bg-white">
  <thead className="bg-indigo-50 text-indigo-600">
    <tr>
      <th className="py-3 px-4 text-center border-b">Sr No.</th>
      <th className="py-3 px-6 text-left border-b">Agency Name</th>
      <th className="py-3 px-6 text-left border-b">Full Name</th>
      <th className="py-3 px-6 text-left border-b">Email</th>
      <th className="py-3 px-6 text-left border-b">Mobile</th>
      <th className="py-3 px-6 text-left border-b">Status</th>
    </tr>
  </thead>
  <tbody>
    {currentAgencies.map((agency, index) => (
      <tr
        key={agency._id}
        className="hover:bg-indigo-50 transition-colors"
      >
        <td className="py-3 px-4 border-b text-center text-gray-800">
          {index + 1}
        </td>
        <td className="py-3 px-6 border-b text-gray-800">{agency.agencyName}</td>
        <td className="py-3 px-6 border-b text-gray-800">{agency.fullName}</td>
        <td className="py-3 px-6 border-b text-gray-800">{agency.email}</td>
        <td className="py-3 px-6 border-b text-gray-800">{agency.mobile}</td>
        <td className="py-3 px-6 border-b">
          <select
            value={agency.status ? "active" : "pending"}
            onChange={(e) => handleStatusChange(agency._id, e.target.value)}
            className="rounded-md border border-gray-300 py-1 px-2 text-sm"
          >
            <option value="pending">Pending</option>
            <option value="active">Active</option>
          </select>
        </td>
      </tr>
    ))}
    {currentAgencies.length === 0 && (
      <tr>
        <td colSpan={6} className="py-4 text-center text-gray-600">
          No agency requests found.
        </td>
      </tr>
    )}
  </tbody>
</table>

        </div>

        {/* Pagination */}
        <div className="mt-8 flex justify-center">
          <nav>
            <ul className="flex gap-4">
              <li>
                <button
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg transition hover:bg-gray-300 disabled:opacity-50"
                >
                  Previous
                </button>
              </li>
              {[...Array(Math.ceil(agencies.length / agenciesPerPage))].map(
                (_, index) => (
                  <li key={index}>
                    <button
                      onClick={() => paginate(index + 1)}
                      className={`px-4 py-2 rounded-lg transition ${
                        currentPage === index + 1
                          ? "bg-indigo-600 text-white"
                          : "bg-gray-200 text-gray-800"
                      }`}
                    >
                      {index + 1}
                    </button>
                  </li>
                )
              )}
              <li>
                <button
                  onClick={() => paginate(currentPage + 1)}
                  disabled={
                    currentPage === Math.ceil(agencies.length / agenciesPerPage)
                  }
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg transition hover:bg-gray-300 disabled:opacity-50"
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default AgencyRequests;